<template>
  <div>
    <b-card>
      <div class="organism-ticket-management_header card-padding flex-wrap">
        <span class="header__label">Ticket Management</span>
        <div v-if="hasUpdateTicketPermission" class="d-flex flex-wrap">
          <atom-button
            buttonId="create-new-ticket"
            class="header__button mt-1 mt-md-0"
            buttonStyle="border"
            @click="onClickCreateNewTicket"
          >
            <template>New Ticket</template>
          </atom-button>
          <atom-button
            buttonId="create-new-incident"
            class="mt-1 mt-md-0 ml-2"
            buttonStyle="border"
            @click="onClickCreateNewIncident"
          >
            <template>New Incident / Job</template>
          </atom-button>
        </div>
      </div>
      <div class="filter-container card-padding pt-0">
        <div class="row mt-0">
          <div class="col-12 col-md-6 col-lg-3">
            <atom-multi-select
              v-model="filterList.type"
              title="Type"
              placeholder="All Type"
              label="name"
              :option="typeOption"
            ></atom-multi-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
            <atom-multi-select
              v-model="filterList.status"
              title="Status"
              placeholder="All Status"
              label="name"
              :option="statusOption"
            ></atom-multi-select>
          </div>
          <div class="col-12 col-lg-5 mt-1 mt-lg-0">
            <atom-multi-select
              v-model="filterList.priority"
              title="Priority"
              placeholder="All Priority"
              label="name"
              :option="priorityOption"
            ></atom-multi-select>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-md-6 col-lg-3">
            <atom-input
              v-model="filterList.ticketId"
              title="Ticket ID"
              placeholder="Ticket ID"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mt-1 mt-md-0">
            <atom-input
              v-model="filterList.idcId"
              :title="contractIdLabel"
              :placeholder="contractIdLabel"
              type="number"
              :maxLength="8"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-6 mt-1 mt-lg-0">
            <atom-input
              v-model="filterList.subjectDetail"
              title="Subject/Detail"
              placeholder="Subject/Detail"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-lg-3">
            <atom-multi-select
              v-model="filterList.department"
              title="Department"
              placeholder="All Department"
              label="name"
              :option="departmentOption"
            ></atom-multi-select>
          </div>
          <div class="col-12 col-lg-9 mt-1 mt-lg-0">
            <atom-select
              v-model="filterList.createdBy"
              title="Created By"
              placeholder="Created By"
              label="name"
              :option="createdByOption"
            ></atom-select>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-md-6 col-lg-3 w-100 mt-1 mt-lg-0">
            <div>
              <atom-datepicker
                datepickerId="molecule-date-picker-period--start"
                title="Start Date"
                v-model="filterList.dateTime.start"
                :maxDate="
                  filterList.dateTime.end
                    ? filterList.dateTime.end
                    : filterList.dateTime.now
                "
                type="dateNtime"
                placeholder="Select Start Date"
                class="molecule-date-picker-period--start"
                :isDisabled="!filterList.isEnableDate"
              ></atom-datepicker>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 w-100 mt-1 mt-lg-0">
            <div>
              <atom-datepicker
                datepickerId="molecule-date-picker-period--en"
                title="End Date"
                v-model="filterList.dateTime.end"
                :minDate="filterList.dateTime.start"
                :maxDate="filterList.dateTime.now"
                type="dateNtime"
                placeholder="Select End Date"
                class="molecule-date-picker-period--end"
                :isDisabled="!filterList.isEnableDate"
              ></atom-datepicker>
            </div>
          </div>
          <div
            class="col-12 col-lg-3 d-flex mt-1 mt-lg-0 justify-content-end justify-content-lg-start"
          >
            <div class="d-flex flex-column">
              <label>Filter Date?</label>
              <atom-switch
                v-model="filterList.isEnableDate"
                class="filter__switch"
              ></atom-switch>
            </div>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-2"
              ></atom-button>
              <div
                class="d-flex reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="ticket-table table-wrapper col-12">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="fields"
            :hover="true"
            @row-clicked="selectRow"
            show-empty
          >
            <template #cell(status)="data">
              <b-badge
                pill
                :variant="badgeVariant(data.value)"
                class="badge--width"
                >{{ badgeStatus(data.value) }}</b-badge
              >
            </template>
            <template #cell(id)="data">
              <div class="issue-id-wrapper">
                <div v-if="data.value.idc" class="header">
                  {{ `${contractIdLabel}: ${data.value.idc}` }}
                </div>
                <div v-if="data.item.isShowTypeOnTable" class="header">
                  {{ getTicketType(data.item.type) }}
                </div>
                <div class="sub-header">{{ data.value.ticket }}</div>
                <div class="sub-header">{{ data.value.customerName }}</div>
              </div>
            </template>
            <template #cell(createdDate)="data">
              <div>{{ data.value.date }}</div>
              <div class="sub-header">{{ data.value.time }}</div>
            </template>
            <template #cell(content)="data">
              <div class="content-container-width">
                <div class="header">{{ data.value.subject }}</div>
                <div class="sub-header d-flex">
                  <span class="custom-ticket-detail-max-width"
                    >{{ data.value.detail }}
                  </span>
                </div>
              </div>
            </template>
            <template #cell(priority)="data">
              <div v-if="data.value === 'CRITICAL'" class="priority__critical">
                Critical
              </div>
              <div v-if="data.value === 'HIGH'" class="priority__high">
                High
              </div>
              <div v-if="data.value === 'MEDIUM'" class="priority__medium">
                Medium
              </div>
              <div v-if="data.value === 'LOW'" class="priority__low">Low</div>
            </template>
            <template #cell(siteAndDepartment)="data">
              <molecule-site-and-department-display
                :site-and-department="data.value"
              />
            </template>
            <template #cell(communication)="data">
              <div v-if="data.value.createdBy">
                <span class="header">{{ data.value.createdBy }}</span
                ><br />
                <span class="sub-header">{{ data.value.createdAt }}</span
                ><br />
                <div class="custom-max-width d-flex sub-header">
                  <span class="custom-sub-max-width">{{
                    data.value.threadMessage
                  }}</span>
                  <div
                    class="custom-margin-left-6"
                    :id="'ticket-threadMessage' + data.index"
                  >
                    <feather-icon
                      icon="InfoIcon"
                      size="12"
                      class="alert__icon"
                    />
                  </div>
                  <b-tooltip
                    :target="'ticket-threadMessage' + data.index"
                    placement="right"
                    boundary="window"
                    variant="primary"
                  >
                    <div class="description__container">
                      <div>{{ data.value.threadMessage }}</div>
                    </div>
                  </b-tooltip>
                </div>
              </div>
              <div v-else>No Reply</div>
            </template>
            <template #cell(internalThread)="data">
              <div v-if="data.value.createdBy">
                <span class="header">{{ data.value.createdBy }}</span
                ><br />
                <span class="sub-header">{{ data.value.createdAt }}</span
                ><br />
                <div class="custom-max-width d-flex sub-header">
                  <span class="custom-sub-max-width">{{
                    data.value.internalThreadMessage
                  }}</span>
                  <div
                    class="custom-margin-left-6"
                    :id="'ticket-internalThreadMessage' + data.index"
                  >
                    <feather-icon
                      icon="InfoIcon"
                      size="12"
                      class="alert__icon"
                    />
                  </div>
                  <b-tooltip
                    :target="'ticket-internalThreadMessage' + data.index"
                    placement="right"
                    boundary="window"
                    variant="primary"
                  >
                    <div class="description__container">
                      <div>{{ data.value.internalThreadMessage }}</div>
                    </div>
                  </b-tooltip>
                </div>
              </div>
              <div v-else>No Reply</div>
            </template>
            <template v-if="hasDeleteTicketPermission" #cell(deleteIcon)="data">
              <atom-button
                buttonId="button-delete"
                iconLeft="Trash2Icon"
                buttonStyle="flat"
                buttonColor="secondary"
                :isDisable="!(data.item.status === 'OPENED')"
                @click="clickDeleteTicket(data)"
              ></atom-button>
            </template>
            <template #empty>
              <div
                class="d-flex flex-column align-items-center justify-content-center my-4"
              >
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <molecule-pagination-with-per-page
        :page="filterList.currentPage"
        :total-count="filterList.totalCount"
        :per-page="filterList.perPage"
        @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
      ></molecule-pagination-with-per-page>
    </b-card>
    <footer style="height: 1px"></footer>

    <!-- Modal Start-->
    <section name="modal">
      <molecule-modal-dialog
        modalId="ticket-management__confirm-delete"
        :isTextCenter="true"
        :textTitle="`Do you want to delete\n“${ticketId}” ?`"
        buttonTextLeft="Delete"
        buttonColorLeft="danger"
        @clickButtonLeft="clickConfirmDeleteTicket"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </div>
</template>

<script>
import mixinsDateTime from "@/mixins/mixinsDatetime"
import { BCard, BTable, BBadge, BTooltip, VBTooltip } from "bootstrap-vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import Ripple from "vue-ripple-directive"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeSiteAndDepartmentDisplay from "@/components/molecules/MoleculeSiteAndDepartmentDisplay.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"
import mixins from "@/mixins"
import { TicketType } from "@/constants"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismTicketManagement",
  components: {
    BCard,
    BTable,
    BBadge,
    AtomMultiSelect,
    AtomButton,
    AtomInput,
    AtomSwitch,
    AtomDatepicker,
    BTooltip,
    MoleculeModalDialog,
    MoleculeSiteAndDepartmentDisplay,
    MoleculePaginationWithPerPage,
    AtomSelect,
  },
  mixins: [mixins, mixinsDateTime, mixinsUser],
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    typeOption: {
      required: true,
      type: Array,
    },
    statusOption: {
      required: true,
      type: Array,
    },
    priorityOption: {
      required: true,
      type: Array,
    },
    departmentOption: {
      required: true,
      type: Array,
    },
    createdByOption: {
      required: true,
      type: Array,
    },
    fields: {
      type: Array,
      required: false,
      default: [],
    },
    items: {
      type: Array,
      required: false,
      default: [],
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      // modal
      modalId: null,

      // ticket
      ticketId: null,
    }
  },
  computed: {
    hasUpdateTicketPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_WRITE)
    },
    hasDeleteTicketPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_DELETE)
    },
  },
  methods: {
    // click button search
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    // click row
    selectRow(record, index) {
      this.$emit("clickRow", record, index)
    },

    // click button create new ticket
    onClickCreateNewTicket() {
      this.$router.push({ name: "internalCreateNewTicket" })
    },

    // click button create new incident
    onClickCreateNewIncident() {
      this.$router.push({ name: "internalCreateNewIncident" })
    },

    // click button delete
    clickDeleteTicket(data) {
      this.ticketId = data.item.id.ticket

      this.modalId = "ticket-management__confirm-delete"
      this.openModal(this.modalId)
    },

    // click confirm delete
    clickConfirmDeleteTicket() {
      this.$emit("clickDelete", this.ticketId)
      this.closeModal()
    },

    // table
    badgeVariant(status) {
      if (status === "OPENED") return "light-primary"
      else if (status === "IN_PROGRESS") return "light-warning"
      else return "light-secondary"
    },
    badgeStatus(status) {
      if (status === "OPENED") return "Opened"
      else if (status === "IN_PROGRESS") return "In Progress"
      else return "Closed"
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    getTicketType(ticketType) {
      switch (ticketType) {
        case TicketType.NORMAL:
          return "Ticket"
        case TicketType.INCIDENT:
          return "Incident"
        case TicketType.JOB:
          return "Job"
        default:
          return ticketType
      }
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper ::v-deep.b-table-sticky-header {
  min-height: 600px;
  max-height: calc(100vh - 625px);
  &:has(.b-table-empty-row) {
    min-height: 350px;
  }
}

.organism-ticket-management_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}

.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.filter__switch {
  padding-top: 10px;
  height: fit-content;
}

.priority__critical {
  font-weight: 600;
  font-size: 14px;
  color: #ea5455;
}

.priority__high {
  font-size: 14px;
  color: #ea5455;
}

.priority__medium {
  font-size: 14px;
  color: #ff9f43;
}

.priority__low {
  font-size: 14px;
  color: #28c76f;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

.issue-id-wrapper {
  width: 140px;
}

.custom-max-width {
  max-width: 200px;
}

.content-container-width {
  min-width: 200px;
}

.custom-sub-max-width {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @supports (-webkit-line-clamp: 3) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}

.custom-ticket-detail-max-width {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;

  @supports (-webkit-line-clamp: 4) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}
</style>
